import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesReportsPhotoMain } from './modules/ui/Main';

const ReportsPhotoPage = (
  <SuspensePage>
    <PagesReportsPhotoMain />
  </SuspensePage>
);

export default ReportsPhotoPage;
